import type { PropsWithChildren } from 'react';
import React from 'react';
import { GovFlex } from '@gov-design-system-ce/react/gov-flex';
import type { GovFlexProps } from '@gov-design-system-ce/react/gov-flex';

export type DSGovFlexProps = PropsWithChildren<
	Omit<GovFlexProps, 'classNames' | 'children'> & {
		className?: string;
	}
>;

export const DSGovFlex = (props: DSGovFlexProps) => (
	<GovFlex {...props}>{props.children}</GovFlex>
);
